import { render, staticRenderFns } from "./ContributorDetailsModalSuper.vue?vue&type=template&id=5bd573b1&scoped=true"
import script from "./ContributorDetailsModalSuper.vue?vue&type=script&lang=js"
export * from "./ContributorDetailsModalSuper.vue?vue&type=script&lang=js"
import style0 from "./ContributorDetailsModalSuper.vue?vue&type=style&index=0&id=5bd573b1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bd573b1",
  null
  
)

export default component.exports